import { Component, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebSocketSubject, webSocket } from 'rxjs/webSocket';
import { Subscription } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { MarkdownModule } from 'ngx-markdown';
import { Auth } from '../../services/auth';
import { Api } from '../../services/api';
import { Dialog } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { SystemDown } from '../system-down/system-down';
import { MessageService } from 'primeng/api';
import { Toast } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { NohtmlDirective } from '../../directives/nohtml.directive';
import { TableModule } from 'primeng/table';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { RippleModule } from 'primeng/ripple';
import { SessionTimeoutPopup } from '../session-timeout-popup/session-timeout-popup';
import { Router } from '@angular/router';
import { PopupDownTime } from '../popup-down-time/popup-down-time';
import { Common } from '../../services/common';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-chat-window',
  imports: [CommonModule, FormsModule, MarkdownModule, Dialog, ButtonModule, SystemDown, Toast,
    TooltipModule, NohtmlDirective, TableModule, SelectModule, ButtonModule, InputTextModule,
    TextareaModule, RippleModule, SessionTimeoutPopup, PopupDownTime],
  providers: [MessageService],
  templateUrl: './chat-window.component.html',
  styleUrl: './chat-window.component.scss'
})
export class ChatWindowComponent {
  @ViewChild('scrollContainer') private scrollContainer!: ElementRef;
  isFocused: boolean = false;
  loadSite: boolean = false;
  private readonly lightThemeSelectedIcon = 'assets/images/light-theme-selected-icon.svg';
  private readonly darkThemeSelectedIcon = 'assets/images/dark-theme-selected-icon.svg';
  private readonly darkThemeIcon = 'assets/images/dark-theme-icon.svg';
  private readonly lightThemeIcon = 'assets/images/light-theme-icon.svg';
  private readonly historyIconDark = 'assets/images/history-white.svg';
  private readonly historyIconLight = 'assets/images/history.svg';
  loaderIcon = 'assets/images/loader2.gif';
  historyIconHover = 'assets/images/history-blue.svg';
  sendIcon = 'assets/images/send-icon.svg';
  activeSendIcon = 'assets/images/active-send-icon.svg';
  sendIconDark = 'assets/images/send-icon-dark.svg';
  micIcon = 'assets/images/mic-icon.svg';
  micIconDark = 'assets/images/mic-icon-dark.svg';
  sendIconDarkActive = 'assets/images/send-icon-dark-active.svg';
  cognizantLogo = 'assets/images/cognizant-logo.png';
  cognizantDarkLogo = 'assets/images/cognizant-logo-dark.png';
  userProfilePic = 'assets/images/user-chat-icon.png';
  botProfilePic = 'assets/images/chatbot-icon.svg';
  botProfilePicWhite = 'assets/images/chatbot-icon-white.svg';
  typingLoader = 'assets/videos/loader.gif';
  rightPanelExpansionIconDark = 'assets/images/expand-right-panel-dark.svg';
  rightPanelExpansionIconLight = 'assets/images/expand-right-panel-light.svg';
  rightPanelCollapseIconDark = 'assets/images/collapse-right-panel-dark.svg';
  rightPanelCollapseIconLight = 'assets/images/collapse-right-panel-light.svg';
  barGraphIconDark = 'assets/images/bar-graph-icon-dark.svg';
  barGraphIconLight = 'assets/images/bar-graph-icon-light.svg';
  barGraphImage = 'assets/images/bar-graph.svg';
  barGraphStackedImage = 'assets/images/bar-graph-stacked.svg';
  noHistoryIcon = 'assets/images/no_checkins.png';
  historyLoaderIcon = 'assets/images/loader_spinner.gif';
  processDetailsIcon = 'assets/images/copy-blue.svg';
  processDetailsLightIcon = 'assets/images/copy-white.svg';
  holidayIcon = 'assets/images/holiday.svg';
  logoutIcon = 'assets/images/logout.svg';
  logoutIconDark = 'assets/images/logout-black.svg';
  logoutIconHover = 'assets/images/logout-blue.svg';
  closeIcon = 'assets/images/closeX.svg';
  completedIcon = 'assets/images/completed-process.svg';
  pendingIcon = 'assets/images/pending-process.svg';
  calendarIcon = 'assets/images/calendar.svg';
  pendingSlaIcon = 'assets/images/pending-warn.svg';
  addedSlaIcon = 'assets/images/added-tick.svg';
  slaSelectedIcon = 'assets/images/selected-tick.svg';
  circleBlink = 'assets/images/animated-blinking-dot.svg';

  chatCharacterLimit: number = 3200;
  isSystemDown: boolean = false; // flag to indicate if system is down for maintenance based on WebSocket messages
  isHoliday: boolean = false; // flag to indicate if today is a holiday
  holidayDate: string = '';
  holidayName: string = '';
  isBotTyping: boolean = false;
  conversationStarted: boolean = false;
  projectSelected: boolean = false;
  processSelected: boolean = false;
  selectedProject: string = '';
  selectedProcess: string = '';
  showProcessSelection: boolean = false;
  conversationClosed: boolean = false;
  projects: any[] = [];
  currentProjectDetails: any = null;
  currentProcessDetails: any = null;
  nextProjectDetails: any = null;
  nextSelectedProject: string = '';
  nextProcessDetails: any = null;
  nextSelectedProcess: string = '';
  projectOptions: { label: string; value: string; status: string }[] = [];
  processOptions: { label: string; value: string; status: string }[] = [];
  projectLocked: boolean = false; // set to true to disable project dropdown after selection
  processLocked: boolean = false; // set to true to disable process dropdown after selection
  fteCount: number | null = null; // new field for FTE count input
  fteCountUpdated: boolean = false; // flag to show success message after FTE count update
  FTEupdateConfirmation: boolean = false; // flag to show FTE update confirmation dialog
  fteCountUpdateError: boolean = false; // flag to show error message after FTE count update
  conversationSummary: Array<any> | null = null;
  currentConversationId: string | null = null;
  userDetails: any = {};
  userName: string = '';
  welcomeTimeStamp: string = '';
  welcomeMessages: string[] = [];
  welcomeMessageErrors: string[] = [];
  showWelcomeMessages: boolean = false;
  showWelcomeMessagesError: boolean = false;
  messages: Array<any> = [];
  totalCheckInsCount: string = '0';
  pendingCheckInsCount: string = '-';
  completedCheckInsCount: string = '-';
  currentDayDate: string = '';
  historyConversations: any[] = [];
  inprogressHistory: any[] = [];
  completedHistory: any[] = [];
  todayIssuesCount: string = '-';
  holidays: any[] = [];
  refreshHistory: boolean = false;
  confirmLogout: boolean = false;
  inputOptions: any = {};
  conversationEdited: boolean = false;
  severityOptions = Array<{ label: string, value: number }>();
  reasonOptions = Array<{ label: string, value: number }>();
  impactAreaOptions = Array<{ label: string, value: number }>();
  clonedConversationSummary: Array<any> = [];
  summaryTableEditable: boolean = false;
  isConnectionLost: boolean = false;
  requestId: string = this.generateUUID();
  sessionId: string = '';
  showIssueOpener: boolean = false;
  showContinueChat: boolean = false;
  summaryValidationError: boolean = false;
  summaryValidationErrorMsg: string = "Can't save! Revenue Impact/Margin Impact/FTE cannot be empty";
  slaReasonText: string = '';
  selectedSLA: Array<number> = [];
  editSummaryItem: any = {};

  klApiEnabled: boolean = environment.klApi;
  isRegularFlow: boolean = true;
  isFriday: boolean = this.isFridayFlowNow();
  progressionTitle: string = this.isFriday ? 'Weekly Check-Ins' : 'Daily Check-Ins';
  selectedTheme: string = 'light';
  userTextMessage: string = '';
  sidebarExpanded = false;
  showHistoryTabs = false;
  showSummaryTableEditing = false;
  selectedIssueId: string = '';
  historyLoader = false;
  noHistory = false;
  historyError = false;
  processDetailsShow = false;
  activeHistoryTab: 'in-progress' | 'completed' = 'in-progress';
  historyItems = {
    inProgress: [
      { project: 'Total - Total E MPS Payroll pro', process: 'Clinical Site Management - Mumbai', comments: "Reviewed payroll integration status. No new risks identified." },
      { project: 'Alphabet Inc - Google T&S Brand Safety LIS', process: '3M eBus: US FUZE Web Services - Chennai', comments: "Discussed resource attrition and SLA performance" }
    ],
    completed: [
      { project: 'Total - Total E MPS Payroll pro', process: 'Clinical Site Management - Mumbai', comments: "Reviewed payroll integration status. No new risks identified." }
    ]
  };
  visibleSessionTimerPopupNext = false;
  sessionPopupState: 1 | 2 | 3 = 1;

  // flags (reset on refresh / relogin)
  private popup1Shown = false;
  private popup2Shown = false;

  // timers
  private hourlyTimerId: any;
  private minuteTimerId: any;

  // Popup‑1 window: 11:30 AM → 11:45 AM
  private readonly POPUP1_START = 11 * 60 + 30;
  private readonly POPUP1_END = 11 * 60 + 45;

  // Popup‑2 window: 11:45 AM → 12:00 PM
  private readonly POPUP2_START = 11 * 60 + 45;
  private readonly POPUP2_END = 12 * 60;

  // Critical hour (11 AM → 12 PM)
  private readonly TARGET_HOUR = 11;

  showPopup2TemporaryScreen = false;

  currentRows: number = 1;
  readonly minRows: number = 1;
  readonly maxRows: number = 5;

  constructor(private readonly authService: Auth, private readonly apiService: Api,
    private readonly messageService: MessageService, private readonly router: Router,
    private readonly commonService: Common) { }

  // 1. Define the WebSocket Subject
  // WebSocketSubject is a special Subject that can both listen (subscribe) and send (.next)
  private socket$: WebSocketSubject<any> | undefined;
  // To manage the lifecycle of the connection
  private socketSubscription: Subscription | undefined;
  // Hardcoded URL as requested
  // private readonly wsUrl = 'wss://genai-eus-pulseagent-poc-as01.azurewebsites.net/ws?name=Naveen&available_projects=[1000372570,1000420907]';
  // private readonly wsUrl = 'wss://genai-eus-pulseagent-poc-as01.azurewebsites.net//ws?name=Anurag&available_projects=["1000372570 - Alphabet Inc. - Google T%26S Brand Safety LIS","1000420907 - Total - Total E MPS Payroll pro"]';
  private wsUrl = 'wss://genai-eus-pulseagent-poc-as01.azurewebsites.net//ws?name=User&available_projects=["1000372570 - Project A","1000420907 - Project B"]';

  isFridayFlowNow(): boolean {
    const today = new Date();
    return today.getDay() === 5 && today.getHours() >= 12; // 5 represents Friday && after 12 PM
  }

  setTheme(theme: string) {
    this.selectedTheme = theme;
    localStorage.setItem('selectedTheme', theme); //save the selected theme to local storage
  }

  loadTheme(): void {
    const storedTheme = localStorage.getItem('selectedTheme');
    // if (storedTheme) {
    //   this.selectedTheme = storedTheme;
    // }
    if (storedTheme === 'dark' || storedTheme === 'light') {
      this.selectedTheme = storedTheme;
    } else {
      // ✅ default to light
      this.selectedTheme = 'light';
      localStorage.setItem('selectedTheme', 'light');
    }

  }

  get checkInProgressPercent(): number {
    const total = Number(this.totalCheckInsCount);
    const completed = Number(this.completedCheckInsCount);
    if (!total || Number.isNaN(total) || Number.isNaN(completed)) {
      return 0;
    }
    return Math.min(100, Math.max(0, Math.round((completed / total) * 100)));
  }

  reloadApp(): void {
    window.location.href = window.location.origin + '/';
  }

  get lightThemeDisplayIcon(): string {
    return this.selectedTheme === 'light' ? this.lightThemeSelectedIcon : this.lightThemeIcon;
  }

  get darkThemeDisplayIcon(): string {
    return this.selectedTheme === 'dark' ? this.darkThemeSelectedIcon : this.darkThemeIcon;
  }

  get historyIcon(): string {
    return this.selectedTheme === 'dark' ? this.historyIconDark : this.historyIconLight;
  }

  get logoutDisplayIcon(): string {
    return this.selectedTheme === 'dark' ? this.logoutIcon : this.logoutIconDark;
  }

  get chatBotIcon(): string {
    return this.selectedTheme === 'dark' ? this.botProfilePicWhite : this.botProfilePic;
  }

  ngOnInit(): void {
    this.loadTheme();
    this.userDetails = this.authService.getUserDetails();
    if (this.userDetails) {
      this.userName = this.userDetails.flm_name || this.getFirstName(this.userDetails.name);
      this.userProfilePic = this.userDetails.picture || this.userProfilePic;
      this.fetchProjectsForUser();
    } else {
      console.error('User details not found in AuthService.');
      this.router.navigate(['/unauthorized']); // redirect to unauthorized page if user details are not available
    }
    // Example initial messages (you can remove this later)
    // this.messages.push({ sender: 'bot', content: 'Hello! How can I help you? Hello! How can I help you? Hello! How can I help you? Hello! How can I help you? Hello! How can I help you? Hello! How can I help you?' });
    // this.messages.push({ sender: 'user', content: 'I have a question. I have a question. I have a question. I have a question. I have a question. I have a question. ' });
    // this.startConversation();

    // immediate evaluation (login inside window)
    this.evaluateTimeWindows();

    const currentHour = new Date().getHours();

    if (currentHour === this.TARGET_HOUR) {
      this.startMinuteChecks();
    } else {
      this.startHourlyCheck();
    }

  }

  startHourlyCheck() {
    const now = new Date();
    const msToNextHour =
      (60 - now.getMinutes()) * 60000 -
      now.getSeconds() * 1000 -
      now.getMilliseconds();

    setTimeout(() => {
      this.checkHour();

      this.hourlyTimerId = setInterval(
        () => this.checkHour(),
        60 * 60 * 1000
      );
    }, msToNextHour);
  }

  checkHour() {
    const hour = new Date().getHours();

    if (hour === this.TARGET_HOUR) {
      this.startMinuteChecks();
      clearInterval(this.hourlyTimerId);
    }

    // after 12 PM → stop all
    if (hour >= 12) {
      this.stopAllTimers();
    }
  }

  startMinuteChecks() {
    this.evaluateTimeWindows();

    const now = new Date();
    const msToNextMinute =
      (60 - now.getSeconds()) * 1000 - now.getMilliseconds();

    setTimeout(() => {
      this.evaluateTimeWindows();

      this.minuteTimerId = setInterval(
        () => this.evaluateTimeWindows(),
        60000
      );
    }, msToNextMinute);
  }

  evaluateTimeWindows() {
    const now = new Date();
    const mins = now.getHours() * 60 + now.getMinutes();

    /** ✅ POPUP 2 WINDOW END CLEANUP — MUST BE FIRST **/
    if (
      this.showPopup2TemporaryScreen &&
      mins >= this.POPUP2_END
    ) {
      this.handlePopup2WindowEnd();
      return;
    }

    /** 🔴 POPUP 2 HAS ABSOLUTE PRIORITY **/
    if (
      mins >= this.POPUP2_START &&
      mins < this.POPUP2_END &&
      !this.popup2Shown
    ) {
      // Force-close any existing popup (Popup 1 or stale state)
      this.visibleSessionTimerPopupNext = false;

      // Open Popup 2
      this.openPopup(2);
      this.popup2Shown = true;

      // Show temporary popup‑down background
      this.showPopup2TemporaryScreen = true;

      return;
    }

    /** ⛔ Prevent Popup 1 from opening if a popup is already visible **/
    if (this.visibleSessionTimerPopupNext) return;

    /** 🟡 POPUP 1 WINDOW **/
    if (
      mins >= this.POPUP1_START &&
      mins < this.POPUP1_END &&
      !this.popup1Shown
    ) {
      this.openPopup(1);
      this.popup1Shown = true;
    }
  }

  private handlePopup2WindowEnd(): void {
    // ✅ hide temporary screen
    this.showPopup2TemporaryScreen = false;

    // ✅ close popup if still open
    this.visibleSessionTimerPopupNext = false;

    // ✅ disconnect websocket safely
    if (this.socketSubscription) {
      this.socketSubscription.unsubscribe();
      this.socketSubscription = undefined;
    }

    // ✅ reload window
    window.location.reload();
  }

  openPopup(state: 1 | 2) {
    this.sessionPopupState = state;
    this.visibleSessionTimerPopupNext = true;
  }

  onPopupClosed() {
    this.visibleSessionTimerPopupNext = false;
  }

  stopAllTimers() {
    if (this.hourlyTimerId) clearInterval(this.hourlyTimerId);
    if (this.minuteTimerId) clearInterval(this.minuteTimerId);
  }

  fetchHolidayList(): void {
    this.apiService.getHolidayList(this.userDetails.eid.toString()).subscribe({
      next: (response: any) => {
        this.loadSite = true;
        console.log('Holiday list for user:', response);
        if (response && response.holidays && response.holidays.length > 0) {
          const today = new Date();
          response.holidays.forEach((holiday: any) => {
            const holidayDate = new Date(holiday.CalendarDate);
            if (holidayDate.toDateString() === today.toDateString()) {
              this.isHoliday = true;
              this.holidayDate = holidayDate.toDateString();
              this.holidayName = holiday.HolidayDescription;
            }
          });
        }
        if (!this.isHoliday) {
          this.loadTheme();
          this.initiateChat();
        }
      },
      error: (err: any) => {
        console.error('Error fetching holiday list:', err);
        if (err.status === 401) {
          console.log('Unauthorized access - logging out');
          this.router.navigate(['/unauthorized']);
        } else {
          this.isSystemDown = true; // set system down flag to show maintenance message based on API error
          this.loadSite = true;
        }
      }
    });
  }

  initiateChat(): void {
    this.conversationClosed = false;
    this.conversationSummary = null; // reset summary
    this.fetchDailyCheckIns();
    this.fetchInputOptions();
    let dailyOrWeekly = this.isFriday ? 'weekly' : 'daily';
    this.welcomeMessages = [
      `Hi! Let’s start your ${dailyOrWeekly} check-in`,
      'Before we continue, please select your project and process'
    ];
    this.welcomeMessageErrors = [
      'Hi! We are having trouble fetching your projects right now.',
      'Please try refreshing the page or check back later.'
    ];
  }

  getFirstName(fullName: string): string {
    return fullName ? fullName.split(' ')[0] : 'User';
  }

  fetchInputOptions(): void {
    this.apiService.getInputOptions().subscribe({
      next: (response: any) => {
        console.log('Gathered Input options:', response);
        this.severityOptions = response.severities.map((severity: any) => ({
          label: severity.severity,
          value: severity.severity_id
        }));
        this.reasonOptions = response.reasons.map((reason: any) => ({
          label: reason.reason,
          value: reason.id
        }));
        this.impactAreaOptions = response.impact_areas.map((impactArea: any) => ({
          label: impactArea.impact,
          value: impactArea.impact_id
        }));
      },
      error: (err: any) => {
        console.error('Error fetching input options:', err);
      }
    });
  }

  fetchProjectsForUser(): void {
    const associateId = this.userDetails.eid || '';
    // const associateId = '2333336'; // hardcoded for testing
    this.isBotTyping = true; // show loader while fetching projects
    this.apiService.getProjectsForUser(associateId).subscribe({
      next: (response: any) => {
        this.loadSite = true;
        console.log('Projects for user:', response);
        this.isBotTyping = false; // hide loader after fetching projects
        this.welcomeTimeStamp = this.getCurrentTimestamp(); // set welcome message timestamp after fetching projects
        this.showWelcomeMessages = true; // show welcome messages after fetching projects
        if (!response.projects || response.projects.length === 0) {
          // this.showWelcomeMessagesError = true;
          // this.welcomeMessageErrors = [
          //   'Hi ' + this.getFirstName(this.userDetails.name) + '! We couldn\'t find any projects associated with your account.',
          //   'Please contact your administrator for project access.'
          // ];
          this.projects = []; // ensure projects is empty if no projects returned
          this.router.navigate(['/no-assignment']); // redirect to no-assignment page if no projects found
        } else {
          this.generateProjectOptions(response.projects);
          this.projects = response.projects; // store full project details for later use
          this.initiateChat(); // start chat after successfully fetching projects
        }
      },
      error: (err: any) => {
        console.error('Error fetching projects:', err);
        console.log('Error while fetching projects: Assuming system is down for maintenance or network issues. Showing system down message.');
        this.isBotTyping = false; // hide loader in case of error

        if (err.status === 401) {
          console.log('Unauthorized access - logging out');
          this.router.navigate(['/unauthorized']);
        } else {
          this.isSystemDown = true; // set system down flag to show maintenance message based on API error
          this.loadSite = true;
          // this.welcomeTimeStamp = this.getCurrentTimestamp();
          // this.showWelcomeMessagesError = true; // show error messages if fetching projects fails
          // this.router.navigate(['/no-assignment']); // redirect to no-assignment page if no projects found or error occurs while fetching projects
        }
      }
    });
    // This function can be used to fetch projects from the server based on the logged-in user
    // For now, we are using hardcoded project options in the template
  }

  generateProjectOptions(projects: any[]): void {
    this.projectOptions = projects.map((proj: any) => ({
      label: proj.ProjectName,
      value: proj.ProjectId,
      status: proj.processes.some((proc: any) => proc.ConversationStatus.toLowerCase() !== 'completed') ? '' : 'completed'
    }));
  }

  getProcessesForProject(projectId: number | string): void {
    const project = this.projects.find(proj => proj.ProjectId == projectId);
    console.log('Selected project details:', project);
    if (project) {
      this.currentProjectDetails = project; // store selected project details for sidebar display
      this.processOptions = project.processes.map((proc: any) => ({
        label: proc.ProcessName,
        value: proc.PFLMId,
        status: proc.ConversationStatus.toLowerCase() || ''
      }));
    }
  }

  updateFTECount(): void {
    const payload = {
      Process_FLM_Loc_Map_id: this.getCurrentProcessFLMId(),
      AssociateID: this.userDetails.eid,
      FTECount: this.fteCount
    }
    this.apiService.updateFTECount(payload).subscribe({
      next: (response: any) => {
        if (response && response === 'Success') {
          this.currentProcessDetails.FTECount = this.fteCount; // update FTE count in current process details to reflect the change in sidebar
          this.currentProjectDetails.processes = this.currentProjectDetails.processes.map((proc: any) => {
            if (proc.ProcessId === this.currentProcessDetails.ProcessId) {
              return { ...proc, FTECount: this.fteCount };
            }
            return proc;
          });
          this.acknowledgeFTEUpdate(true);
          this.messageService.add({ severity: 'success', summary: 'FTE Count Updated', detail: 'FTE count updated successfully.' });
          console.log('FTE count updated successfully:', response);
          // You can show a success message or perform any other actions here
        } else {
          this.acknowledgeFTEUpdate(false);
        }
      },
      error: (err: any) => {
        console.error('Error updating FTE count:', err);
        this.acknowledgeFTEUpdate(false);
        this.messageService.add({ severity: 'error', summary: 'FTE Count Update Failed', detail: 'Error while updating the FTE count. Please try again.' });
        // You can show an error message or perform any other actions here
      }
    });
  }

  cancelFTEUpdate(): void {
    this.FTEupdateConfirmation = false;
    this.fteCount = this.currentProcessDetails?.FTECount || null; // reset FTE count input to current value if update is cancelled
  }

  acknowledgeFTEUpdate(success: boolean): void {
    this.fteCountUpdated = success; // show success message
    this.fteCountUpdateError = !success; // hide error message
    setTimeout(() => {
      this.fteCountUpdated = false; // hide success message after 1.5 seconds
      this.fteCountUpdateError = false; // hide error message after 1.5 seconds
    }, 1500);
  }

  clearFTEerror(): void {
    this.fteCountUpdated = false; // hide success message when user starts editing FTE count
    this.fteCountUpdateError = false; // hide error message when user starts editing FTE count
  }

  disableFTECountUpdate(): boolean {
    if (this.currentProcessDetails && this.currentProcessDetails.FTECount !== undefined) {
      return this.fteCount === null || this.fteCount.toString().length < 1 || this.fteCount == this.currentProcessDetails.FTECount;
    }
    return true;
  }

  fetchDailyCheckIns(): void {
    const associateId = this.userDetails.eid;
    this.apiService.getDailyCheckins(associateId).subscribe({
      next: (response: any) => {
        console.log('Daily check-ins for user:', response);
        // this.noHistory = response.checkins.length === 0;
        this.totalCheckInsCount = response.total_assigned || '0';
        this.pendingCheckInsCount = response.pending;
        this.completedCheckInsCount = response.completed;
        // You can process and display the check-in history as needed
      },
      error: (err: any) => {
        console.error('Error fetching daily check-ins:', err);
      }
    });
  }

  showCheckInHistory(tabToActive: string = 'in-progress'): void {
    this.historyLoader = true;
    // this.setHistoryTab((tabToActive === 'completed') ? 'completed' : 'in-progress');
    this.sidebarExpanded = true;
    this.showHistoryTabs = true;
    this.processDetailsShow = false;
    this.showSummaryTableEditing = false;
    const associateId = this.userDetails.eid;
    this.apiService.getCheckinHistory(associateId).subscribe({
      next: (response: any) => {
        console.log('Check-in history for user:', response);
        this.historyError = false;
        this.noHistory = (response.conversations && response.conversations.length === 0) ? true : false;
        this.historyConversations = response.conversations || [];
        this.inprogressHistory = this.historyConversations.filter((conv: any) => ['in progress', 'active'].includes(conv.status.toLowerCase()));
        this.completedHistory = this.historyConversations.filter((conv: any) => conv.status.toLowerCase() === 'completed');
        this.historyLoader = false;
      },
      error: (err: any) => {
        this.historyError = true;
        this.noHistory = true;
        this.historyLoader = false;
        console.error('Error fetching check-in history:', err);
      }
    });
    this.currentDayDate = this.getDayAndDate(new Date().toISOString());
  }

  fetchTodayIssuesCount(): void {
    const pflmId = this.getCurrentProcessFLMId();
    this.apiService.getTotalIssues(pflmId).subscribe({
      next: (response: any) => {
        console.log('Today issues count for user:', response);
        this.todayIssuesCount = response.total_issues_logged; // store the issues count for display
        // You can process and display the issues count as needed
      },
      error: (err: any) => {
        console.error('Error fetching today issues count:', err);
      }
    });
  }

  formatHolidayDate(dateString: string): string {
    return new Date(dateString).toDateString();
  }

  checkIfTodayHoliday(holidays: any[]): void {
    if (holidays && holidays.length > 0) {
      const today = new Date();
      holidays.forEach((holiday: any) => {
        const holidayDate = new Date(holiday.CalendarDate);
        if (holidayDate.toDateString() === today.toDateString()) {
          this.isHoliday = true;
          this.holidayDate = holidayDate.toDateString();
          this.holidayName = holiday.HolidayDescription;
        }
      });
    }
  }

  async fetchHolidays(): Promise<any> {
    const pflmId = this.getCurrentProcessFLMId();
    return new Promise((resolve, reject) => {
      this.apiService.getHolidays(pflmId).subscribe({
        next: (response: any) => {
          console.log('Holidays for user:', response);
          this.holidays = response.holidays || []; // store the holidays for display
          this.checkIfTodayHoliday(this.holidays);
          resolve(response);
        },
        error: (err: any) => {
          console.error('Error fetching holidays:', err);
          reject(err);
        }
      });
    });
  }

  showProcessDetails(): void {
    this.sidebarExpanded = true;
    this.showHistoryTabs = false;
    this.processDetailsShow = true;
    this.showSummaryTableEditing = false;
  }

  startConversation(): void {
    this.isRegularFlow = environment.fridayFlowOnly ? false : this.getSlaProbedue() === 0 ? true : false;
    this.messages = []; // clear previous messages
    this.conversationSummary = null;
    this.conversationClosed = false;
    this.conversationStarted = true;
    this.isConnectionLost = false;
    setTimeout(() => this.scrollToBottom(), 10);
  }

  onProjectChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    this.selectedProject = selectElement.value;
    this.conversationStarted = false;
    this.conversationClosed = false;
    this.messages = []; // clear messages when project changes to prepare for new conversation
    this.selectedProcess = ''; // reset selected process when project changes
    this.currentProcessDetails = null; // reset current process details when project changes to clear sidebar info
    this.processSelected = false; // reset process selected flag when project changes
    if (this.processDetailsShow) {
      this.processDetailsShow = false; // hide process details if currently shown when project changes
      this.sidebarExpanded = false;
    }
    this.isHoliday = false;
    this.onProjectSelected(); // trigger actions based on project selection
    console.log('Selected project:', this.selectedProject);
  }

  onProcessChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    this.selectedProcess = selectElement.value;
    console.log('Selected process:', this.selectedProcess);
    this.isHoliday = false; // reset holiday flag when process changes
    this.onProcessSelected(); // trigger actions based on process selection
  }

  onProjectSelected(): void {
    this.getProcessesForProject(this.selectedProject); // update processes based on selected project
    this.projectSelected = this.selectedProject !== '';
    this.showProcessSelection = this.projectSelected; // show process dropdown only after project is selected
  }

  async onProcessSelected(conversation_id: string | null = null, status: string = ''): Promise<void> {
    console.log('Process selected, fetching details for process ID:', this.selectedProcess);
    this.currentProcessDetails = this.getProcessDetails(this.selectedProcess); // store selected process details for sidebar display
    console.log('Current process details:', this.currentProcessDetails);
    this.fteCount = this.currentProcessDetails?.FTECount || null; // set FTE count input based on selected process details
    this.processSelected = this.selectedProcess !== '';
    await this.fetchHolidays().then(() => {
      this.fetchTodayIssuesCount(); // fetch issues count when process is selected
      if (this.isHoliday) {
        console.log("Holiday Today; not starting conversation");
        setTimeout(() => this.scrollToBottom(), 10);
        return; // if today is a holiday, do not proceed with fetching issues count or starting conversation
      } else {
        this.startConversation(); // trigger conversation start after process selection
        this.currentConversationId = conversation_id !== null ? conversation_id : this.currentProcessDetails.ConversationId || null;
        this.refreshHistory = false;
        if (this.klApiEnabled) {
          if (conversation_id && conversation_id !== 'null' && conversation_id !== '') {
            // this.fetchChatHistory();
            this.sessionId = ''; // reset session ID for new conversation
            this.connectChat('start', false, status);
          } else {
            this.startSession();
          }
        } else {
          this.connect(this.currentConversationId); // connect to WebSocket after process selection
          // this.fetchConversationSummary(); // for testing
        }
      }
    });
  }

  getProcessDetails(pflmId: number | string): any {
    if (!this.currentProjectDetails) {
      return null;
    }
    return this.currentProjectDetails.processes.find((proc: any) => proc.PFLMId == pflmId);
  }

  getCurrentProjectName(): string {
    return this.currentProjectDetails ? this.currentProjectDetails.ProjectName : '';
  }

  getCurrentAccountName(): string {
    return this.currentProjectDetails ? this.currentProjectDetails.AccountName : '';
  }

  getCurrentProjectId(): string {
    return this.currentProjectDetails ? this.currentProjectDetails.ProjectId : '';
  }

  getCurrentProcessId(): string {
    return this.currentProcessDetails ? this.currentProcessDetails.ProcessId : '';
  }

  getCurrentProcessName(): string {
    return this.currentProcessDetails ? this.currentProcessDetails.ProcessName : '';
  }

  getCurrentProcessFLMId(): string {
    return this.currentProcessDetails ? this.currentProcessDetails.PFLMId : '';
  }

  getCurrentProcessStatus(): string {
    return this.currentProcessDetails ? this.currentProcessDetails.ConversationStatus : '';
  }

  getSlaProbedue(): number {
    return this.currentProcessDetails && this.currentProcessDetails.SlaProbedue ? Number(this.currentProcessDetails.SlaProbedue) : 0;
  }

  getCurrentTimestamp(): string {
    return this.formatTimestamp(new Date().toISOString());
  }

  currentTimestamp(): string {
    return new Date().toISOString();
  }

  getNextProjectName(): string {
    return this.nextProjectDetails ? this.nextProjectDetails.ProjectName : '';
  }

  getNextProjectId(): string {
    return this.nextProjectDetails ? this.nextProjectDetails.ProjectId : '';
  }

  getNextProcessName(): string {
    return this.nextProcessDetails ? this.nextProcessDetails.ProcessName : '';
  }

  getNextProcessFLMId(): string {
    return this.nextProcessDetails ? this.nextProcessDetails.PFLMId : '';
  }

  openProcess(item: any, status: string = ''): void {
    this.refreshHistory = true;
    this.currentConversationId = item.conversation_id || null;
    const projectId = item.project_id;
    const pflmId = item.process_flm_loc_map_id;
    this.messages = []; // clear previous messages to load the conversation of the selected history item
    this.showIssueOpener = false;
    this.conversationSummary = null; // reset conversation summary when opening a history item to prepare for new summary based on the selected conversation
    this.selectedProject = projectId; // set selected project to the project of the selected history item
    this.onProjectSelected(); // trigger project selected actions to load processes for the selected project 
    this.showProcessSelection = true;
    this.selectedProcess = pflmId; // set selected process to the process of the selected history item
    this.projectSelected = true; // mark project as selected to show process dropdown
    this.processSelected = true; // mark process as selected to trigger conversation start and WebSocket connection in onProcessSelected()
    this.conversationClosed = false; // mark conversation as open in case it was closed previously to allow loading the conversation of the selected history item
    this.conversationStarted = false; // mark conversation as started to show chat window
    this.currentProjectDetails = this.projects.find(proj => proj.ProjectId == projectId) || null; // set current project details based on selected history item
    // this.currentProcessDetails = this.currentProjectDetails ? this.currentProjectDetails.processes.find((proc: any) => proc.PFLMId == pflmId) || null : null;
    this.isHoliday = false;
    this.onProcessSelected(this.currentConversationId, status); // trigger process selected actions with the conversation ID of the selected history item to load the conversation and connect to WebSocket with the correct conversation ID
    // this.connect(this.currentConversationId); // connect to WebSocket with conversation ID to load the previous conversation
  }

  startNewCheckIn(): void {
    // Logic to start a new check-in, e.g., reset states, clear messages, etc.
    this.conversationStarted = false;
    this.conversationClosed = false;
    this.projectSelected = false;
    this.processSelected = false;
    this.showProcessSelection = false;
    this.selectedProject = '';
    this.selectedProcess = '';
    this.showIssueOpener = false;
    this.messages = [];
    this.conversationSummary = null;
    this.showWelcomeMessages = true;
    this.projectLocked = false; // unlock project selection for new check-in
    this.processLocked = false; // unlock process selection for new check-in
    this.sidebarExpanded = false; // collapse sidebar for new check-in
    this.initiateChat();
  }

  pickNextProcess(): void {
    console.log('Picking next process for check-in. Next selected project:', this.nextSelectedProject, 'Next selected process:', this.nextSelectedProcess);
    this.conversationStarted = false;
    this.conversationClosed = false;
    this.selectedProject = this.nextSelectedProject;
    this.onProjectSelected();
    this.selectedProcess = this.nextSelectedProcess;
    this.projectSelected = true;
    this.processSelected = true;
    this.projectLocked = false;
    this.processLocked = false;
    this.showIssueOpener = false;
    this.showProcessSelection = true;
    this.conversationSummary = null;
    this.currentProjectDetails = this.nextProjectDetails;
    this.currentProcessDetails = this.nextProcessDetails;
    this.showWelcomeMessages = true;
    this.messages = [];
    // this.initiateChat();
    this.onProcessSelected(); // directly trigger process selected actions to start conversation and connect to WebSocket with new process details
  }

  setUpNextCheckIn(): void {
    console.log("Setting up next check-in details based on current selections.");
    console.log('Selected Project:', this.selectedProject);
    console.log('Selected Process:', this.selectedProcess);
    const availaleProcessOfCurrentProject = this.projects.find(proj => proj.ProjectId == this.selectedProject)?.processes.filter((proc: any) => (proc.PFLMId != this.getCurrentProcessFLMId() && proc.ConversationStatus.toLowerCase() !== 'completed')) || [];
    if (availaleProcessOfCurrentProject.length > 0) {
      console.log('Available processes in current project for next check-in:', availaleProcessOfCurrentProject);
      this.nextProcessDetails = availaleProcessOfCurrentProject[0]; // default to first available active process
      this.nextSelectedProcess = availaleProcessOfCurrentProject[0].PFLMId; // set selected process to the default active process
      this.nextProjectDetails = this.projects.find(proj => proj.ProjectId == this.selectedProject); // set next project details based on current selected project
      this.nextSelectedProject = this.selectedProject; // set next selected project same as current selected project
    } else {
      const allOtherActiveProcesses = this.projects.flatMap(proj => proj.processes.filter((proc: any) => (proc.PFLMId != this.getCurrentProcessFLMId() && proc.ConversationStatus.toLowerCase() !== 'completed')));
      console.log('Available active processes across all projects for next check-in:', allOtherActiveProcesses);
      if (allOtherActiveProcesses.length > 0) {
        this.nextProjectDetails = this.projects.find(proj => proj.ProjId == allOtherActiveProcesses[0].ProjId); // set next project details based on the project of the default active process
        this.nextSelectedProject = this.nextProjectDetails?.ProjectId; // set next selected project based on the project of the default active process
        console.log('Next project details set to:', this.nextProjectDetails);
        console.log('Next selected project set to:', this.nextSelectedProject);
        this.nextProcessDetails = allOtherActiveProcesses[0]; // default to first available active process across all projects
        this.nextSelectedProcess = allOtherActiveProcesses[0].PFLMId; // set selected process to the default active process
        console.log('Next process details set to:', this.nextProcessDetails);
        console.log('Next selected process set to:', this.nextSelectedProcess);
      } else {
        console.log('No active processes available for next check-in.');
        this.nextProcessDetails = null; // no active processes available
        this.nextProjectDetails = null;
        this.nextSelectedProcess = '';
        this.nextSelectedProject = '';
      }
    }
  }

  isActiveHistoryItem(item: any): boolean {
    return this.currentProcessDetails ? this.currentProcessDetails.PFLMId == item.process_flm_loc_map_id : false;
  }

  startNextCheckIn(): void {
    this.pickNextProcess();
  }

  getIssueType(flag: string): string {
    return this.commonService.getIssueType(flag);
  }

  isUpdatedFlag(flag: string): boolean {
    return ['updated', 'update'].includes(flag.toLowerCase());
  }

  getSeverityLabel(severityValue: number): string {
    const severityOption = this.severityOptions.find(option => option.value === severityValue);
    return severityOption ? severityOption.label : '-';
  }

  getImpactAreaLabel(impactAreaValue: number): string {
    const impactAreaOption = this.impactAreaOptions.find(option => option.value === impactAreaValue);
    return impactAreaOption ? impactAreaOption.label : '-';
  }

  getReasonLabel(reasonValue: number): string {
    const reasonOption = this.reasonOptions.find(option => option.value == reasonValue);
    return reasonOption ? reasonOption.label : '-';
  }

  conversationRowChanged(): void {
    this.conversationEdited = true;
    // setTimeout(() => this.scrollToBottom(), 100);
  }

  allowDigitsWithDecimal(event: KeyboardEvent): void {
    this.commonService.allowDigitsWithDecimal(event);
  }

  allowDigitsOnly(event: KeyboardEvent): void {
    this.commonService.allowDigitsOnly(event);
  }

  preventDragDrop(event: DragEvent): void {
    event.preventDefault();
  }

  getLastMessage(): Array<any> {
    if (this.messages && this.messages.length > 0) {
      return this.messages.filter(item => item.type === 'message' && !item.custom).slice(-1);
    }
    return [];
  }

  setLastTableMessageNonEditable(): void {
    if (this.messages && this.messages.length > 0) {
      const lastTableMessageIndex = this.messages.map(item => item.type).lastIndexOf('table');
      if (lastTableMessageIndex !== -1) {
        this.messages[lastTableMessageIndex].editable = false;
      }
    }
  }

  continueChat(): void {
    this.showContinueChat = false;
    this.setLastTableMessageNonEditable();
    this.messages.push({ type: 'message', sender: 'user', custom: true, content: 'Continue conversation', timestamp: this.getCurrentTimestamp() });
    this.messages.push(...this.getLastMessage());
    this.showIssueOpener = true;
    setTimeout(() => this.scrollToBottom(), 10);
  }

  isFTEempty(): boolean {
    return this.clonedConversationSummary?.some((item: any) => item.fte === null || item.fte === undefined || item.fte === '');
  }

  isRevenueImpactEmpty(): boolean {
    return this.clonedConversationSummary?.some((item: any) => item.revenue_impact === null || item.revenue_impact === undefined || item.revenue_impact === '');
  }

  isMarginImpactEmpty(): boolean {
    return this.clonedConversationSummary?.some((item: any) => item.margin_impact === null || item.margin_impact === undefined || item.margin_impact === '');
  }

  selectSLA(id: number, msgId: number): void {
    if (this.selectedSLA.includes(id)) {
      this.selectedSLA = this.selectedSLA.filter(slaId => slaId !== id);
    } else {
      this.selectedSLA.push(id);
    }
  }

  isSLASelected(id: number): boolean {
    return this.selectedSLA.includes(id);
  }

  updateSlaReason(): void {
  }

  clearSlaReason(): void {
    this.slaReasonText = '';
    this.selectedSLA = [];
  }

  saveConversationSummary(): void {
    // if (this.isFTEempty() || this.isRevenueImpactEmpty() || this.isMarginImpactEmpty()) {
    //   setTimeout(() => this.scrollToBottom(), 100);
    //   this.summaryValidationError = true;
    // } else {
      this.summaryValidationError = false;
      this.sidebarExpanded = false;
      console.log('Saving conversation summary:', this.clonedConversationSummary);
      this.conversationEdited = false;
      this.isBotTyping = true;
      this.messages?.map(item => {
        if (item.type === 'table') {
          item.editable = false; // make the table non-editable while saving to prevent further changes during the save operation
        }
      });
      setTimeout(() => this.scrollToBottom(), 10);
      const payload = {
        // AssociateId: '222222', // hardcoded for testing
        // ProcessFLMLocMapId: 9522, // hardcoded for testing
        // UpdateConversationId: '50367168-07ed-4550-8d1d-dc0762e34540', // hardcoded for testing
        AssociateId: `${this.userDetails.eid}`,
        ProcessFLMLocMapId: this.getCurrentProcessFLMId(),
        UpdateConversationId: this.currentConversationId || null,
        // IssueList: this.clonedConversationSummary.map((item: any) => ({
        //   issue_id: item.issue_id,
        //   risk_statement: item.risk_statement,
        //   risk_description: item.risk_description,
        //   risk_severity: item.risk_severity,
        //   impact_id: item.impact_id,
        //   business_impact: item.business_impact,
        //   current_state: this.sanitizeCurrentState(item.current_state),
        //   fte: item.fte,
        //   revenue_impact: item.revenue_impact,
        //   margin_impact: item.margin_impact,
        //   comments: item.comments || '',
        //   reason_id: item.reason_id,
        //   overall_summary: item.overall_summary || '',
        //   genai_issue_description: item.genai_issue_description || '',
        //   issue_status: item.issue_status || ''
        // }))
        IssueList: [
          this.editSummaryItem
        ]
      };
      console.log('Payload for saving conversation summary:', payload);
      this.messages.push({ type: 'message', sender: 'user', custom: true, content: 'Save changes', timestamp: this.getCurrentTimestamp() });
      this.editSummaryItem = null;
      this.selectedIssueId = '';
      this.apiService.updateSummarization(payload).subscribe({
        next: (response: any) => {
          this.isBotTyping = false;
          console.log('Conversation summary saved successfully:', response);
          this.messages.push({ type: 'message', sender: 'bot', custom: true, content: 'Your changes have been saved. See the table below. You can continue to update issues while the check-in window is open.' });
          const summaryResponse = this.sortConversationSummaryByIssueId(response.issues);
          summaryResponse.forEach((item: any) => {
            if (item.current_state || item.current_state !== '') {
              item.current_state = this.sanitizeCurrentState(item.current_state);
            }
          });
          this.clonedConversationSummary = summaryResponse;
          this.messages?.push({
            type: 'table',
            sender: 'bot',
            botIcon: 'no',
            editable: true,
            content: this.clonedConversationSummary,
            oldContent: JSON.parse(JSON.stringify(summaryResponse)),
            timestamp: this.getCurrentTimestamp()
          });
          this.showContinueChat = true;
          setTimeout(() => this.scrollToBottom(), 100);
        },
        error: (err: any) => {
          this.isBotTyping = false;
          console.error('Error saving conversation summary:', err);
          this.messages.push({ type: 'message', sender: 'bot', custom: true, content: 'An error occurred while saving your changes. Please try again.', timestamp: this.getCurrentTimestamp() });
          this.showContinueChat = true;
          this.fetchConversationSummary(); // refresh the conversation summary
          setTimeout(() => this.scrollToBottom(), 100);
        }
      });
    // }
  }

  sortConversationSummaryByIssueId(conversationSummary: Array<any>): Array<any> {
    if (conversationSummary && conversationSummary.length > 0) {
      conversationSummary.sort((a: any, b: any) => a.issue_id - b.issue_id);
      console.log('Sorted conversation summary by issue ID:', conversationSummary);
    }
    return conversationSummary;
  }

  sanitizeCurrentState(currentState: string): string {
    return currentState.replace(/\[[^\]]*\]:?\s*/g, ''); // remove any text within square brackets and the colon if present
  }

  fetchConversationSummary(status: string = ''): void {
    const payload = {
      process_flm_loc_map_id: this.getCurrentProcessFLMId(),
      update_conversation_ids: [`${this.currentConversationId || ''}`]
    };
    // const payload = {
    //   process_flm_loc_map_id: 9522, // hardcoded for testing
    //   update_conversation_id: '50367168-07ed-4550-8d1d-dc0762e34540' // hardcoded for testing
    // }
    console.log('Fetching conversation summary with payload:', payload);
    this.isBotTyping = true;
    this.apiService.getSummarization(payload).subscribe({
      next: (response: any) => {
        console.log('Conversation summary:', response);
        this.isBotTyping = false;
        //   response = [
        //     {
        //   "genai_issue_id": 109,
        //   "issue_id": 109,
        //   "associate_id": "2333336",
        //   "process_flm_loc_map_id": 9535,
        //   "issue_status": null,
        //   "issue_category": null,
        //   "genai_issue_description": "Service delay impacting deadline adherence",
        //   "risk_severity": 3,
        //   "risk_statement": "Service delays are affecting adherence to project timelines.",
        //   "risk_description": "Delays in service delivery are risking project deadlines, with potential downstream impacts on client trust and deliverables.",
        //   "impact_id": 3,
        //   "business_impact": "Timeline setbacks could harm client relationships and project outcomes.",
        //   "current_state": "Not provided",
        //   "fte": "80",
        //   "revenue_impact": 50,
        //   "margin_impact": 50,
        //   "comments": null,
        //   "reason_id": 2,
        //   "pending_with_user_role_name": null,
        //   "overall_summary": "Issue updated with additional impact details: Revenue Impact $0.5M, Margin Impact $0.5M, FTE impacted 80. Currently flagged under SLA Performance for further attention and monitoring.",
        //   "flag": "Created",
        //   "created_date": "2026-03-27T11:17:54.470429",
        //   "updated_date": "2026-03-27T11:19:10.125019",
        //   "conversation_id": "88066708-4044-4956-a0de-d997d8d4822b",
        // }
        //   ]
        const summaryIssues = [];
        const conversationId = this.currentConversationId;
        if (conversationId && response && response[conversationId] && response[conversationId].length > 0) {
          summaryIssues.push({ type: 'message', sender: 'bot', custom: true, content: 'Below is the summary of issues that will be logged' });
          const summaryResponse = this.sortConversationSummaryByIssueId(response[conversationId]);
          summaryResponse.forEach((item: any) => {
            if (item.current_state || item.current_state !== '') {
              item.current_state = this.sanitizeCurrentState(item.current_state);
            }
          });
          this.clonedConversationSummary = summaryResponse;
          summaryIssues.push({
            type: 'table',
            sender: 'bot',
            botIcon: 'no',
            editable: true,
            oldContent: JSON.parse(JSON.stringify(summaryResponse)),
            content: summaryResponse,
            // timestamp: response[0].updated_date ? this.formatTimestamp(response[0].updated_date) : this.getCurrentTimestamp()
            timestamp: this.getCurrentTimestamp()
          });
        } else {
          summaryIssues.push({ type: 'message', sender: 'bot', custom: true, content: 'No issues were identified in this check-in. If you believe there is a risk that needs to be logged, please reopen this check-in and provide more details in the chat.' });
          summaryIssues.push({
            botIcon: 'no',
            type: 'table',
            sender: 'bot',
            editable: false,
            oldContent: [],
            content: [],
            timestamp: this.getCurrentTimestamp()
          });
        }
        this.messages = this.messages.concat(summaryIssues);
        this.showContinueChat = true;
        setTimeout(() => this.scrollToBottom(), 10);
      },
      error: (err: any) => {
        console.error('Error fetching conversation summary:', err);
        this.isBotTyping = false;
        if (status.toLowerCase() === 'completed') {
          this.messages.push({ type: 'message', custom: true, sender: 'bot', content: 'An error occurred while fetching the conversation summary!', timestamp: this.getCurrentTimestamp() });
        } else {
          this.messages.push({ type: 'message', custom: true, sender: 'bot', content: 'An error occurred while fetching the conversation summary. Please try again.', timestamp: this.getCurrentTimestamp() });
        }
        this.showContinueChat = true;
        setTimeout(() => this.scrollToBottom(), 10);
      }
    });
  }

  startEditing(editItem: any): void {
    this.summaryValidationError = false;
    this.selectedIssueId = editItem.issue_id;
    this.editSummaryItem = JSON.parse(JSON.stringify(editItem));
    this.processDetailsShow = false;
    this.showHistoryTabs = false;
    this.showSummaryTableEditing = true;
    this.sidebarExpanded = true;
  }

  cancelEditing(messageIndex: number, summaryIndex: number): void {
    this.summaryValidationError = false;
    if (this.messages[messageIndex].content.length === 1) {
      this.conversationEdited = false;
    }
    this.messages[messageIndex].content[summaryIndex] = JSON.parse(JSON.stringify(this.messages[messageIndex].oldContent[summaryIndex])); // revert to old content for the specific row
    this.sidebarExpanded = false;
    this.editSummaryItem = null;
    this.selectedIssueId = '';
  }

  onSidebarClose(): void {
    this.sidebarExpanded = false;
    if (this.selectedIssueId && this.selectedIssueId !== '') {
      this.editSummaryItem = null;
      this.selectedIssueId = '';
    }
  }

  completeCheckIn(): void {
    // Logic to complete the check-in, e.g., update status, show summary, etc.
    this.projects.find(proj => proj.ProjectId == this.selectedProject)?.processes.forEach((proc: any) => {
      if (proc.PFLMId == this.getCurrentProcessFLMId()) {
        proc.ConversationStatus = 'completed';
      }
    });
    this.generateProjectOptions(this.projects);
  }

  fetchChatHistory(): void {
    this.isBotTyping = true;
    this.scrollToBottom();
    this.apiService.getChatHistory(this.getCurrentProcessFLMId(), this.userDetails.eid.toString()).subscribe({
      next: (response: any) => {
        console.log('Chat history response:', response);
        this.isBotTyping = false;
        if (response && response.has_history && response.conversation_count > 0 && response.most_recent) {
          this.currentConversationId = response.most_recent.conversation_id; // set current conversation ID to the most recent conversation ID from the response
          this.handleHistoryMessages(response, response.current_phase);
        } else {
          console.log('No chat history found for this process.');
        }
      },
      error: (err: any) => {
        console.error('Error fetching chat history:', err);
      }
    });
  }

  startSession(): void {
    this.isBotTyping = true;
    this.scrollToBottom();
    const requestId = this.generateUUID();
    const payload = {
      request_id: requestId,
      persona: 'risk_compliance_advisor',
      account: this.getCurrentAccountName(),
      session_id: '',
      project_id: this.getCurrentProjectId(),
      project_name: this.getCurrentProjectName(),
      process_id: this.getCurrentProcessId(),
      process_name: this.getCurrentProcessName(),
      flm_id: this.userDetails.eid,
      flm_name: this.getFirstName(this.userDetails.name),
      process_flm_loc_map_id: this.getCurrentProcessFLMId(),
      skip_sla_dhd: this.isRegularFlow
      // location_id: location_id,
      // location_name: location_name,
    }
    this.apiService.startSession(payload, requestId).subscribe({
      next: (response: any) => {
        console.log('Session start response:', response);
        this.isBotTyping = false;
        if (response && response.session_id && response.request_id) {
          this.sessionId = response.session_id;
          this.requestId = response.request_id;
          if (response.conversation_id && response.conversation_id !== '') {
            this.currentConversationId = response.conversation_id;
          }
          // if (this.isRegularFlow) {
          if (!response.final_output || response.final_output === '') {
            response.final_output = 'Hi, Are there any issues or concerns that you would like to discuss today?';
          }
          let sessionCase = response.session_case ? response.session_case.toLowerCase() : '';
          let currentPhase = response.current_phase ? response.current_phase : '';
          if (sessionCase && sessionCase === 'case_1_fresh' ||
            (sessionCase === 'case_2_resume_empty' && currentPhase.toLowerCase() === 'init') ||
            !response.prior_conversation_text || response.prior_conversation_text.length === 0) {
            this.handleBotResponse(response, true);
          } else {
            // response.isCompletedProcess = (response.current_phase.toLowerCase() === 'closed');
            response.isCompletedProcess = true;
            this.handleHistoryMessages(response, currentPhase);
          }
          // } else {
          //   this.connectChat('Hi', false);
          // }
        }
      },
      error: (err: any) => {
        console.error('Error while starting the chat session:', err);
        this.isBotTyping = false;
        this.handleMessage({ type: 'assistant_text', isError: true, text: 'An error occurred while server is trying to start session. Please try again.', timestamp: this.currentTimestamp() });
      }
    });
  }

  handleReplyPrompt(replyMessage: string, index: number): void {
    this.messages[index].replied = true;
    this.connectChat(replyMessage);
  }

  generateUUID(): string {
    return crypto.randomUUID();
  }

  handleSummaryConfirmationResponse(master_registry: any): void {
    let summaryIssues = [];
    if (master_registry && master_registry.length > 0) {
      summaryIssues.push({ type: 'message', sender: 'bot', content: 'Below is the summary of issues that will be logged' });
      const summaryResponse = this.sortConversationSummaryByIssueId(master_registry);
      this.clonedConversationSummary = summaryResponse;
      summaryIssues.push({
        type: 'table',
        sender: 'bot',
        botIcon: 'no',
        editable: true,
        oldContent: JSON.parse(JSON.stringify(summaryResponse)),
        content: summaryResponse,
        // timestamp: response[0].updated_date ? this.formatTimestamp(response[0].updated_date) : this.getCurrentTimestamp()
        timestamp: this.getCurrentTimestamp()
      });
      setTimeout(() => this.scrollToBottom(), 10);
    } else {
      summaryIssues.push({ type: 'message', sender: 'bot', content: 'No issues were identified in this check-in. If you believe there is a risk that needs to be logged, please reopen this check-in and provide more details in the chat.' });
      summaryIssues.push({
        botIcon: 'no',
        type: 'table',
        sender: 'bot',
        editable: false,
        oldContent: [],
        content: [],
        timestamp: this.getCurrentTimestamp()
      });
    }
    this.messages = this.messages.concat(summaryIssues);
    setTimeout(() => this.scrollToBottom(), 10);
  }

  handleHistoryMessages(response: any, currentPhase: string): void {
    if (response && response.session_id) {
      this.sessionId = response.session_id;
    }
    if (response && response.request_id) {
      this.requestId = response.request_id;
    }
    if (response.conversation_id && response.conversation_id !== '') {
      this.currentConversationId = response.conversation_id;
    }
    const historyMessages = response.prior_conversation_text || [];
    let defaultPrompts: Array<string> = [];
    if (response.session_case.toUpperCase() === 'CASE_2_RESUME_EMPTY' && !this.isRegularFlow
      && historyMessages.filter((msg: any) => msg.role.toLowerCase() === 'assistant').length === 1) {
      response.awaiting_summary_confirmation = true;
      defaultPrompts = ['Proceed'];
    }
    this.sidebarExpanded = false;
    historyMessages.forEach((msg: any) => {
      if (msg.text && msg.text.toLowerCase() !== 'start' && msg.text !== '') {
        this.messages.push({
          type: 'message',
          sender: msg.role.toLowerCase() === 'user' ? 'user' : 'bot',
          content: msg.text,
          replyPrompts: this.isReplyPromptShown(response) ? defaultPrompts : [],
          timestamp: msg.timestamp ? this.formatTimestamp(msg.timestamp) : false
        });
      }
    });
    setTimeout(() => this.scrollToBottom(), 10);
    // if (currentPhase.toLowerCase() === 'closed' || response.isCompletedProcess) {
    if (currentPhase.toLowerCase() === 'closed') {
      this.sidebarExpanded = false;
      this.summaryTableEditable = false;
      this.fetchConversationSummary('completed');
    } //else if (response.isCompletedProcess || (response.prior_conversation_text && response.prior_conversation_text.length > 0)) {
    else if (response.isCompletedProcess) {
      this.showIssueOpener = true;
    }
  }

  openSummaryTable(): void {
    setTimeout(() => this.scrollToBottom(), 10);
    this.sidebarExpanded = false;
    this.summaryTableEditable = false;
    this.showIssueOpener = false;
    this.fetchConversationSummary('completed');
  }

  closeIssueOpener(): void {
    this.showIssueOpener = false;
  }

  isReplyPromptShown(response: any): boolean {
    console.log('confirmation prompt details: ', response.awaiting_summary_confirmation, response.current_phase, response.conversation_quality_report ? response.conversation_quality_report.completion_status : null);
    if (response.awaiting_summary_confirmation) {
      return true;
    } else if (response.current_phase && response.current_phase.toUpperCase() === 'STORAGE'
      && response.conversation_quality_report && response.conversation_quality_report.completion_status
      && response.conversation_quality_report.completion_status.toUpperCase() === 'COMPLETED') {
      return true;
    }
    return false;
  }

  handleBotResponse(response: any, isSessionStarting: boolean = false): void {
    if (response && response.session_id && response.request_id) {
      this.sessionId = response.session_id;
      this.requestId = response.request_id;
      if (response.conversation_id && response.conversation_id !== '') {
        this.currentConversationId = response.conversation_id;
      }
      let defaultPrompts = ['Yes', 'No'];
      if (isSessionStarting && !this.isRegularFlow) {
        response.awaiting_summary_confirmation = true;
        defaultPrompts = ['Proceed'];
      }
      if (response.is_valid) {
        if (response.final_output && response.final_output !== '') {
          this.handleMessage({
            type: 'assistant_text',
            text: response.final_output,
            timestamp: this.currentTimestamp(),
            sla: [
              // {id: 1, title: 'Case respond rate (Support cases)', reason: '', reason_status: 'pending', due_time: 'Aug 2026'},
              // {id: 2, title: 'L1/L1.5 support case only resolved with 24 hrs', reason: '', reason_status: 'pending', due_time: 'Aug 2026'},
              // {id: 3, title: 'Sentiment score (All cases)', reason: 'A policy update was rolled out mid-month without adequate agent training, causing inconsistent case handling. This resulted in incorrect first-time resolutions, higher reopen rates, and frustrated customers reflected in sentiment scores', reason_status: 'added', due_time: 'Aug 2026'}
            ],
            replyPrompts: this.isReplyPromptShown(response) ? defaultPrompts : []
          });
        }
      } else {
        let errorMsg = (response.validation_error && response.validation_error !== '')
          ? response.validation_error : 'Error! No response generated from the assistant. Please try again.';
        this.handleMessage({ type: 'assistant_text', text: errorMsg, isError: true, timestamp: this.currentTimestamp(), replyPrompts: this.isReplyPromptShown(response) ? defaultPrompts : [] });
      }
      // response.current_phase = 'closed';
      if (response.current_phase.toLowerCase() === 'closed' && !isSessionStarting) {
        this.isBotTyping = false;
        this.conversationClosed = true;
        this.processLocked = false;
        this.projectLocked = false;
        this.completeCheckIn();
        this.fetchDailyCheckIns(); // refresh check-in counts in topbar
        this.handleSummaryConfirmationResponse(response.master_registry);
      }
      // console.log('Final Issues: ' + response.final_issues);
      // console.log('Master Registry: ' + response.master_registry);
      // response.master_registry = [
      //     {
      //       issue_id: 611,
      //       risk_statement: "Insufficient database data blocking delivery operations",
      //       issue_uuid: "5be58685-92b7-4bbb-b7e9-ca6be1d43f08",
      //       action: "UPDATE",
      //       source_phase: "DHD",
      //       impact_area: "IT/Infrastructural",
      //       risk_severity: 3,
      //       current_state: "[2026-06-10 13:54 IST — 2333336] Immediate data population has been identified as necessary; action to fill the database gaps is underway.\n[2026-06-12 15:05 IST — 2450963] Waiting for Management approval\n- [Navaneetha-2026-10-06]: The issue is awaiting management approval, and the required database data has still not been populated. Delivery operations continue to be blocked as a result.",
      //       business_impact: "Fifteen staff members are unable to perform their delivery functions due to the data gap, resulting in a significant operational standstill across the team.",
      //       fte: 15,
      //       revenue_impact: 50.0,
      //       margin_impact: 50.0,
      //       reason_id: 1,
      //       risk_description: "Critical database records remain incomplete, preventing the team from executing delivery operations. Management approval is still pending, and no resolution has been implemented to date.",
      //       issue_category: "Not Assigned",
      //       impact_id: 7,
      //       flag: "UPDATE"
      //     },
      //     {
      //       issue_uuid: "8c3a3489-3b77-4445-80c2-a9e18f78bd23",
      //       action: "NEW",
      //       source_phase: "REGULAR",
      //       risk_description: "The team is unable to deploy and release the project due to missing server access. Eight team members are currently blocked, and the release cannot proceed until access is provisioned.",
      //       current_state: "- [Navaneetha-2026-10-06]: The project is ready for release and can be deployed as soon as the required server access is granted. An access request is in progress, pending resolution from the provisioning team.",
      //       business_impact: "A two-day delay has been incurred due to the access blockage, with eight team members unable to proceed. The stalled release represents a significant risk to delivery timelines and revenue.",
      //       fte: 8,
      //       revenue_impact: 50.0,
      //       margin_impact: 40.0,
      //       mitigation_text: "1. Immediately escalate the access request to the highest available authority on both the client and vendor sides — given the $50M revenue impact and 8 team members blocked, this warrants executive-level intervention today rather than routing through standard IT ticketing queues.\n2. While escalation is in progress, identify whether any single authorized team member can be granted emergency or temporary elevated access to perform the deployment on behalf of the full team, reducing the bottleneck to one critical path item.\n3. Set a hard deadline of end-of-business today for a confirmed access resolution timeline from the provisioning team, and establish an hourly check-in cadence between the project manager and the access owner to prevent further delays from communication gaps.",
      //       risk_statement: "Deployment server access blocking project release",
      //       reason_id: 1,
      //       impact_area: "IT/Infrastructural",
      //       risk_severity: 3,
      //       issue_category: "Not Assigned",
      //       issue_id: 743,
      //       impact_id: 7,
      //       flag: "NEW"
      //     },
      //     {
      //       issue_uuid: "5569153e-629e-4832-a6a9-37ae96c0cda2",
      //       action: "NEW",
      //       source_phase: "REGULAR",
      //       risk_statement: "General project concern logged with significant revenue and margin impact",
      //       risk_description: "A general project concern has been raised and logged, flagging substantial revenue and margin exposure. The specific root cause and scope have not yet been fully defined.",
      //       current_state: "- [Navaneetha-2026-10-06]: The concern has been formally raised as a logged issue. Further investigation and structured follow-up are required to identify ownership, root cause, and resolution timelines.",
      //       business_impact: null,
      //       fte: 8,
      //       revenue_impact: 50.0,
      //       margin_impact: 40.0,
      //       mitigation_text: "1. Given the substantial $50M revenue and $40M margin exposure flagged by 8 team members, escalate this log immediately to senior leadership and the client executive sponsor to ensure visibility and prioritize resolution within the next 48 hours.\n2. Convene a focused working session with the 8 impacted team members to clearly define the specific root cause, scope, and immediate containment actions, converting this general log into a structured issue with an assigned owner and target resolution date.\n3. Establish a weekly checkpoint cadence to track progress against this logged concern, ensuring that impact metrics are monitored and any deterioration in revenue or margin exposure triggers an automatic escalation protocol.",
      //       reason_id: 1,
      //       impact_area: "IT/Infrastructural",
      //       risk_severity: 3,
      //       issue_category: "Not Assigned",
      //       issue_id: 744,
      //       impact_id: 7,
      //       flag: "NEW"
      //     }
      //   ];
      //   this.handleSummaryConfirmationResponse(response.master_registry);
    }
  }

  connectChat(message: string, msgShow: boolean = true, status: string = ''): void {
    this.isBotTyping = true;
    if (msgShow) {
      this.handleMessage({ type: 'user_message', text: message, timestamp: this.currentTimestamp() }); // show user message in chat immediately
    }
    const payload = {
      user_message: message,
      request_id: this.requestId,
      persona: 'risk_compliance_advisor',
      account: this.getCurrentAccountName(),
      session_id: this.sessionId,
      action: 'start',
      project_id: this.getCurrentProjectId(),
      project_name: this.getCurrentProjectName(),
      process_id: this.getCurrentProcessId(),
      process_name: this.getCurrentProcessName(),
      flm_id: this.userDetails.eid,
      flm_name: this.getFirstName(this.userDetails.name),
      process_flm_loc_map_id: this.getCurrentProcessFLMId(),
      skip_sla_dhd: this.isRegularFlow // false for Friday flow
    };
    this.apiService.connectChat(payload, this.requestId).subscribe({
      next: (response: any) => {
        console.log('Chat connection response:', response);
        this.isBotTyping = false;
        if (response.session_case && response.session_case.toLowerCase() !== 'case_1_fresh'
          && response.prior_conversation_text && response.prior_conversation_text.length > 0) {
          response.isCompletedProcess = (status.toLowerCase() === 'completed');
          this.handleHistoryMessages(response, response.current_phase);
        } else {
          this.handleBotResponse(response);
        }
      },
      error: (err: any) => {
        console.error('Error connecting chat:', err);
        this.handleMessage({ type: 'assistant_text', isError: true, text: 'An error occurred while connecting to the server. Please try again.', timestamp: this.currentTimestamp() });
        this.isBotTyping = false;
      }
    });
  }

  connect(conversationId: string | null = null): void {
    this.wsUrl = `wss://genai-eus-pulseagent-dev-as01.azurewebsites.net//ws?name=${this.getFirstName(this.userDetails.name)}&project_id=${this.getCurrentProjectId()}&associate_id=${this.userDetails.eid}&pflm_id=${this.getCurrentProcessFLMId()}`;
    if (conversationId && conversationId !== null && conversationId.trim() !== '') {
      this.wsUrl += `&conversation_id=${conversationId}`;
    }
    // if (this.getSlaProbedue() === 1) {
    //   this.wsUrl += `&sla_probe_flow=1`;
    // }
    console.log('Connecting to WebSocket with URL:', this.wsUrl);
    this.socket$ = webSocket(this.wsUrl);

    this.socketSubscription = this.socket$.subscribe({
      next: (msg) => {
        console.log('Received from server:', msg);
        this.handleMessage(msg);
      }, // Called whenever a message comes from server
      error: (err) => this.handleError(err), // Called if connection fails
      complete: () => console.log('WebSocket connection closed') // Called when connection ends
    });
  }

  handleError(error: any): void {
    console.error('WebSocket error:', error);
    this.isBotTyping = false;
    if (error.type.toLowerCase() === 'close') {
      this.isConnectionLost = true;
    } else {
      this.messages.push({
        sender: 'bot',
        type: 'message',
        content: 'Connection lost. Refresh the page and select the project-process to continue the check-in',
        timestamp: this.getCurrentTimestamp(),
        isError: true
      });
      setTimeout(() => this.scrollToBottom(), 100);
    }
  }

  // 4. Message Handling: Process incoming data
  handleMessage(msg: any): void {
    let content = '';
    switch (msg.type) {
      case 'conversation_started':
      case 'conversation_resumed':
      case 'conversation':
        this.isBotTyping = true;
        setTimeout(() => this.scrollToBottom(), 10);
        this.currentConversationId = msg.conversation_id || this.currentConversationId; // update conversation ID if provided in the message
        return;
      case 'started':
        this.isBotTyping = false;
        // if (msg.message === 'Server is ready to chat!') {
        //   // 🔽 Show loader immediately when initiating 
        //   this.isBotTyping = true;
        //   // this.sendUserMessage('Initiate', false);
        //   setTimeout(() => this.scrollToBottom(), 10);
        // }
        if (this.sidebarExpanded && this.showHistoryTabs) {
          this.showCheckInHistory('in-progress'); // auto-load history when a conversation starts
        }
        return;
      case 'conversation_history':
        this.isBotTyping = false;
        if (msg.conversation && Array.isArray(msg.conversation) && msg.conversation.length > 0) {
          this.messages = msg.conversation
            .filter((convItem: any) => convItem.role.toLowerCase() !== 'initiate') // filter out 'Initiate' messages from history
            .map((convItem: any) => ({
              sender: convItem.role.toLowerCase() === 'user' ? 'user' : 'bot',
              type: 'message',
              content: convItem.text,
              timestamp: convItem.timestamp ? this.formatTimestamp(convItem.timestamp) : false
            }));
          setTimeout(() => this.scrollToBottom(), 100);
          this.sidebarExpanded = false;
          this.summaryTableEditable = false;
          if (this.getCurrentProcessStatus().toLowerCase() === 'completed') {
            this.fetchConversationSummary('completed');
          }
        }
        return;

      case 'conversation_summary':
        this.isBotTyping = false;
        this.conversationSummary = [{
          FTE: msg.summary?.FTE ?? '',
          RiskStatement: msg.summary?.RiskStatement ?? '',
          RiskDescription: msg.summary?.RiskDescription ?? '',
          RevenueImpact: msg.summary?.RevenueImpact ?? '',
          MarginImpact: msg.summary?.MarginImpact ?? '',
          Severity: msg.summary?.Severity ?? '', // new field 
          ImpactArea: msg.summary?.ImpactArea ?? '', // new field 
          timestamp: msg.timestamp ? this.formatTimestamp(msg.timestamp) : '' // empty if not present
        }];
        // 🔽 Trigger auto-scroll after table is rendered 
        setTimeout(() => this.scrollToBottom(), 100);
        return;

      // 🔽 Ignore critical_error messages completely 
      case 'critical_error':
      case 'error':
        this.isBotTyping = false;
        // Do not push to messages or show in UI 
        console.warn('Critical error received, ignoring:', msg.message);
        return;

      // Handle finish event with custom message 
      case 'finish':
        this.isBotTyping = false;
        this.conversationClosed = true; // show label
        this.completeCheckIn(); // mark check-in as completed in the UI
        this.processLocked = false;
        this.projectLocked = false;
        this.summaryTableEditable = true; // make summary table editable on finish
        this.fetchConversationSummary(); // fetch summary when conversation finishes
        this.fetchDailyCheckIns(); // refresh check-in counts in topbar
        if (this.sidebarExpanded && this.showHistoryTabs) {
          this.showCheckInHistory('completed'); // auto-load history sidebar on finish
        }
        return;

      // Normalize content field 
      case 'assistant_text':
        this.isBotTyping = false; // stop loader
        content = msg.text ?? msg.message ?? '';
        this.messages.push({
          type: 'message',
          sender: 'bot',
          content,
          highlight: msg.issue_logged || false,
          replyPrompts: msg.replyPrompts || [],
          isError: msg.isError || false,
          sla: msg.sla || [],
          timestamp: msg.timestamp ? this.formatTimestamp(msg.timestamp) : false
        });
        setTimeout(() => this.scrollToBottom(), 100);
        return;

      case 'user_message':
        content = msg.text ?? msg.message ?? '';
        if (content.toLowerCase() === 'initiate') {
          return;
        }
        this.isBotTyping = true; // expect bot reply
        this.messages.push({
          type: 'message',
          sender: 'user',
          content,
          timestamp: msg.timestamp ? this.formatTimestamp(msg.timestamp) : false
        });
        setTimeout(() => this.scrollToBottom(), 100);
        return;
    }
  }

  // 5. Sending Messages: How to send data to the server
  sendMessage(event?: Event): void {
    if (event instanceof KeyboardEvent) {
      if (event.shiftKey) {
        return;
      }
      event.preventDefault();
    }

    if (!this.userTextMessage.trim()) {
      return;
    }
    if (!this.projectLocked && !this.processLocked) {
      this.projectLocked = true; // lock project selection after sending first message
      this.processLocked = true; // lock process selection after sending first message
      this.setUpNextCheckIn(); // prepare next check-in details after locking current selections
    }
    if (this.klApiEnabled) {
      this.connectChat(this.userTextMessage)
    } else {
      this.sendUserMessage(this.userTextMessage);
    }
    this.userTextMessage = '';

    this.currentRows = 1;

    setTimeout(() => {
      const textarea = document.querySelector('.chat-text-area') as HTMLTextAreaElement;
      if (textarea) {
        textarea.style.height = 'auto';
      }
    });

  }

  sendUserMessage(content: string, showInChat: boolean = true): void {
    if (this.socket$) {
      // Construct the payload your server expects
      const payload = {
        message: content,
        // Add other fields if required, e.g., timestamp, user_id
      };

      // .next() sends the payload as a JSON string over the WebSocket
      this.socket$.next(payload);
    }
  }

  // 2. Helper method to scroll to bottom
  scrollToBottom(): void {
    try {
      this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
    } catch (err) {
      console.error('Scroll to bottom failed', err);
    }
  }

  // 6. ngOnDestroy: Cleanup
  ngOnDestroy(): void {
    // Unsubscribing closes the WebSocket connection automatically
    if (this.socketSubscription) {
      this.socketSubscription.unsubscribe();
    }

    this.stopAllTimers();
  }

  formatTimestamp(timestamp: string): string {
    const date = new Date(timestamp);

    // Extract parts
    const month = date.toLocaleString('en-US', { month: 'short' }); // Jan
    const day = date.getDate().toString().padStart(2, '0');         // 26
    const year = date.getFullYear();                                // 2026

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'pm' : 'am';

    hours = hours % 12;
    if (hours === 0) hours = 12; // handle midnight/noon
    const hourStr = hours.toString().padStart(2, '0');

    // Build final string
    return `${month} ${day}, ${year} - ${hourStr}:${minutes} ${ampm}`;
  }

  getDayAndDate(timestamp: string): string {
    const date = new Date(timestamp);
    const options: Intl.DateTimeFormatOptions = { weekday: 'long', month: 'short', day: 'numeric', year: 'numeric' };
    return date.toLocaleDateString('en-US', options); // e.g., "Monday, Jan 26, 2026"
  }

  setHistoryTab(tab: 'in-progress' | 'completed'): void {
    this.activeHistoryTab = tab;
  }


  toggleSidebar() {
    this.sidebarExpanded = !this.sidebarExpanded;
  }

  logout(): void {
    console.log('Logging out...');
    this.authService.initiateLogout();
  }

  showSessionPopup() {
    this.sessionPopupState = 1;
    this.visibleSessionTimerPopupNext = true;
  }

  adjustTextareaHeight(textarea: HTMLTextAreaElement): void {
    if (!textarea) return;

    // ✅ Force shrink calculation reset (VERY IMPORTANT)
    textarea.style.height = '0px';

    const lineHeight = parseInt(
      window.getComputedStyle(textarea).lineHeight || '28',
      10
    );

    const scrollHeight = textarea.scrollHeight;

    // ✅ Use CEIL (not floor) → better accuracy
    let requiredRows = Math.ceil(scrollHeight / lineHeight);

    // ✅ Clamp between 1 and 5
    requiredRows = Math.max(this.minRows, Math.min(requiredRows, this.maxRows));

    this.currentRows = requiredRows;

    // ✅ Apply correct height
    textarea.style.height = `${requiredRows * lineHeight}px`;

    // ✅ Scrollbar logic
    if (requiredRows >= this.maxRows && scrollHeight > requiredRows * lineHeight) {
      textarea.style.overflowY = 'auto';
    } else {
      textarea.style.overflowY = 'hidden';
    }
  }

}
